import React from 'react';
import type { WorkflowType } from '@this/domain/organization/organization2';
import {
  SubSection,
  SubSectionTitle
} from '@this/components/organization/setting/workflow_setting_section/shared';
import WorkflowSection from '@this/components/organization/setting/workflow_setting_section/workflow_section';

interface DomesticHotelSectionProps {
  domesticHotelUnderRegulationWorkflowType: WorkflowType;
  domesticHotelUnderRegulationBufferAmount: number;
  domesticHotelOverRegulationWorkflowType: WorkflowType;
  domesticHotelOverRegulationBufferAmount: number;
  handleChangeWorkflowType: (type: WorkflowType, target: string) => void;
  handleChangeBufferAmount: (amount: number, target: string) => void;
}

const DomesticHotelSection: React.FC<DomesticHotelSectionProps> = ({
  domesticHotelUnderRegulationWorkflowType,
  domesticHotelUnderRegulationBufferAmount,
  domesticHotelOverRegulationWorkflowType,
  domesticHotelOverRegulationBufferAmount,
  handleChangeWorkflowType,
  handleChangeBufferAmount
}) => {
  return (
    <SubSection>
      <SubSectionTitle>国内ホテル</SubSectionTitle>

      <WorkflowSection
        description="選択したホテルの金額が旅費規定以下の場合"
        itemLabel="ホテル"
        workflowType={domesticHotelUnderRegulationWorkflowType}
        bufferAmount={domesticHotelUnderRegulationBufferAmount}
        target="domesticHotelUnderRegulation"
        showPriceLimitOption
        onChangeWorkflowType={handleChangeWorkflowType}
        onChangeBufferAmount={handleChangeBufferAmount}
      />

      <WorkflowSection
        description="選択したホテルの金額が旅費規定を超えている場合"
        itemLabel="ホテル"
        workflowType={domesticHotelOverRegulationWorkflowType}
        bufferAmount={domesticHotelOverRegulationBufferAmount}
        target="domesticHotelOverRegulation"
        onChangeWorkflowType={handleChangeWorkflowType}
        onChangeBufferAmount={handleChangeBufferAmount}
      />
    </SubSection>
  );
};

export default DomesticHotelSection;
